import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Form, message } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import AgeAgreementWarning from 'components/AgeAgreementWarning';
import Contract from 'components/Contract';
import SaveButton from 'components/SaveButton';
import stickyError from 'components/stickyError';

class PreembarkationForm extends React.Component {
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) {
				this.props.isSubmitted();
				return stickyError(err.message);
			}
			const matchingRemark = this.props.remarks.find(remark => remark.Code === 'VISAPRE');
			let data = Object.assign({}, values, {date: moment().toISOString()});
			if (matchingRemark) data.id = matchingRemark.AssignId;
			axios({
				method: (matchingRemark && matchingRemark.AssignId) ? 'put' : 'post',
				url: apiPath+'/remark/35',
				data: data,
				withCredentials: true
			}).then(result => {
				this.props.isSubmitted();
				this.props.refreshRemarks();
				message.success('Saved!');
			}).catch(error => {
				this.props.isSubmitted();
				this.props.handleAxiosSaveError(error);
			});
		});
	}
	render() {
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'travel/visaform');
			if (redirect) return redirect;
		}

		const matchingRemark = this.props.remarksLoaded && this.props.remarks.find(remark => remark.Code === 'VISAPRE');

		const { getFieldDecorator } = this.props.form;
		const fa19Form = "http://www.semesteratsea.org/wp-content/uploads/2019/04/visapreemFA19.pdf"
		const sp19Form = "http://www.semesteratsea.org/wp-content/uploads/2018/08/visapre-embarkationformsp19.pdf"
		const sp20Form = "https://www.semesteratsea.org/wp-content/uploads/2019/08/visapreemsp20.pdf"
		return (
			<Form className="withSpacing" onSubmit={this.handleSubmit}>
				<p>
					Prior to the start of your voyage it is necessary to acknowledge that you have read and agree to the terms of the below document.
					Please click on the link and read the contents carefully.
					It is recommended that you print the document for your records.
					After you have read the document you must select the check box to acknowledge that you have read and agree to the terms.
					Once the box is checked you may click the Save button.
				</p>
				<AgeAgreementWarning />
				
				<Contract
					getFieldDecorator={getFieldDecorator}
					field="checked"
					initialValue={matchingRemark && matchingRemark.rmkNumericCheck1}
					valueForChecked="1"
					abbreviation="VISA"
					title="Visa Pre-Embarkation Form"
					link={this.props.booking.EventId == 38 ? fa19Form : (this.props.booking.EventId == 39 ? sp19Form :  sp20Form) }
					extraText="This form outlines the types of visas required for SAS voyages, acquisition processes, expectations and responsibilities of both voyagers and ISE, should there be any visa issues before or during the voyage, such as itinerary changes and/or a lost or stolen passport."
					agreeText="I understand and agree to be held responsible for adhering to the regulations, policies, and procedures stated in the Institute for Shipboard Education's (ISE) Visa Pre-Embarkation Form." />

				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.props.getStatus().submitting} />
			</Form>
		);
	}
}

export default withSpin(Form.create()(PreembarkationForm));



// WEBPACK FOOTER //
// ./portal-components/Portal/Travel/PreembarkationForm.jsx